export default __webpack_public_path__ + "static/media/email.ed3db700.png";